import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

import * as PlantillaContabilidadService from 'services/plantillaContabilidad.service'

const PlantillaFormGroup = ({ iOrigen, iError, iTouched, fIsSubmitting, setFieldValue, vTipoDocumento }) => {
  const [plantillasOptions, setPlantillasOptions] = React.useState([])

  React.useEffect(() => {
    PlantillaContabilidadService.getxOrigenAsSelect(iOrigen).then(({ data }) => {
      if (data && data.length > 0) {
        const primeraOpcion = data[0]
        setFieldValue('_idPlantilla', primeraOpcion._id)

        setPlantillasOptions(
          data.map((x, k) => (
            <option key={k} value={x._id}>
              {x.descripcion}
            </option>
          ))
        )
      }
    })
  }, [iOrigen, setFieldValue])

  const onKeyDown = React.useCallback(
    e => {
      if (vTipoDocumento === '50' || vTipoDocumento === '52') {
        KeyEventUtil.leaveOnEnterOrTab('input-anioAduana', e)
      } else if (vTipoDocumento === '03') {
        KeyEventUtil.leaveOnEnterOrTab('input-numeroDocumentoFin', e)
      } else {
        KeyEventUtil.leaveOnEnterOrTab('input-importe', e)
      }
    },
    [vTipoDocumento]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='_idPlantilla'>
          {({ field }) => (
            <Form.Select {...field} id='select-plantilla' isInvalid={iTouched && iError} disabled={fIsSubmitting} onKeyDown={onKeyDown}>
              <option value=''>Seleccionar</option>
              {plantillasOptions}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PlantillaFormGroup)
